import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { FallbackImage } from "@/components/common/FallbackImage";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveProfileTooltipWrapper from "@/components/utils/tooltip/WaveProfileTooltipWrapper";
import { getWavePathRoute } from "@/helpers/navigation.helpers";
export default function DropListItemContentWaveMention(t0) {
  const $ = _c(17);
  const {
    wave
  } = t0;
  const wavePicture = wave.wave?.picture ?? null;
  const t1 = wave.wave_id;
  const t2 = wave.wave ?? null;
  const t3 = wave.wave_name_in_content;
  let t4;
  if ($[0] !== wave.wave_id) {
    t4 = getWavePathRoute(wave.wave_id);
    $[0] = wave.wave_id;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>#</span>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== wave.wave_name_in_content || $[4] !== wavePicture) {
    t6 = wavePicture && <span className="tw-inline-flex tw-h-3 tw-w-3 tw-flex-shrink-0 tw-overflow-hidden tw-rounded-full tw-leading-none"><FallbackImage primarySrc={getScaledImageUri(wavePicture, ImageScale.W_AUTO_H_50)} fallbackSrc={wavePicture} alt={`Wave ${wave.wave_name_in_content} avatar`} width={12} height={12} sizes="12px" className="tw-h-3 tw-w-3 tw-rounded-full tw-object-cover" /></span>;
    $[3] = wave.wave_name_in_content;
    $[4] = wavePicture;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== wave.wave_name_in_content) {
    t7 = <span>{wave.wave_name_in_content}</span>;
    $[6] = wave.wave_name_in_content;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t4 || $[9] !== t6 || $[10] !== t7) {
    t8 = <Link onClick={_temp} href={t4} className="tw-inline-flex tw-items-center tw-gap-1 tw-font-medium tw-text-primary-400 tw-no-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-primary-300 desktop-hover:hover:tw-underline">{t5}{t6}{t7}</Link>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t8 || $[14] !== wave.wave_id || $[15] !== wave.wave_name_in_content) {
    t9 = <WaveProfileTooltipWrapper waveId={t1} initialWave={t2} fallbackName={t3}>{t8}</WaveProfileTooltipWrapper>;
    $[12] = t2;
    $[13] = t8;
    $[14] = wave.wave_id;
    $[15] = wave.wave_name_in_content;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
function _temp(e) {
  return e.stopPropagation();
}